import { create } from 'zustand';

const useAuthStore = create((set) => ({
    token: sessionStorage.getItem('token') || null,

    setToken: (token) => {
        sessionStorage.setItem('token', token);
        set({ token });
    },

    clearToken: () => {
        sessionStorage.removeItem('token');
        set({ token: null });
    },

    isAuthenticated: () => {
        const token = sessionStorage.getItem('token');
        return token !== null && token !== 'undefined';
    },
}));

export default useAuthStore;
